export default inputData => {
  const valueArray = inputData.map(d => d.y * d.x);
  const numberOfResults = inputData.reduce((total, v) => total + v.y, 0);
  return valueArray.reduce((p, c) => p + c, 0) / numberOfResults;
};
